import { domainRegistry } from "#schemas/registry.ts";
import { z } from "zod";

const BRUSH_MIN = 1;
const BRUSH_MAX = 6;

/** Runtime guard for brush size values arriving from MCP/LLM tool calls or persisted state. */
export const BrushSizeSchema = z.int().min(BRUSH_MIN).max(BRUSH_MAX).register(domainRegistry, {
  id: "brush_size",
  title: "Brush size",
  description: `Pixel diameter of the active brush. Integer in [${BRUSH_MIN}, ${BRUSH_MAX}].`,
  surface: "store",
  llmExposed: true,
  persistKey: "brushSize",
  group: "tools",
  examples: [1, 3, 6],
});
export type BrushSize = z.infer<typeof BrushSizeSchema>;

/** Enumerated brush sizes for UI rendering. Derived from schema bounds. */
export const BRUSH_SIZE_VALUES: readonly BrushSize[] = Array.from(
  { length: BRUSH_MAX - BRUSH_MIN + 1 },
  (_, i) => BRUSH_MIN + i,
);
